import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ExtendedAccessModel } from '../interfaces/hierarchy-data';

@Injectable({
    providedIn: 'root',
})
export class UserExtendedAccessService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/UserExtendedAccess').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    save(body): Observable<any> {
        return this.http.post(`${this._url}`, body);
    }

    get(loginEmail: string): Observable<ExtendedAccessModel[]> {
        return this.http.post<ExtendedAccessModel[]>(`${this._url}/get`, {
            Email: loginEmail,
        });
    }
}
